const competitionActionTypes = {
  CREATE_TOURNAMENT_START: "CREATE_TOURNAMENT_START",
  CREATE_TOURNAMENT_SUCCESS: "CREATE_TOURNAMENT_SUCCESS",
  CREATE_TOURNAMENT_FAILURE: "CREATE_TOURNAMENT_FAILURE",

  CREATE_CHALLENGE_START: "CREATE_CHALLENGE_START",
  CREATE_CHALLENGE_SUCCESS: "CREATE_CHALLENGE_SUCCESS",
  CREATE_CHALLENGE_FAILURE: "CREATE_CHALLENGE_FAILURE",

  CREATE_ONE_V_ONE_START: "CREATE_ONE_V_ONE_START",
  CREATE_ONE_V_ONE_SUCCESS: "CREATE_ONE_V_ONE_SUCCESS",
  CREATE_ONE_V_ONE_FAILURE: "CREATE_ONE_V_ONE_FAILURE",

  FETCH_COMPETITIONS_START: "FETCH_COMPETITIONS_START",
  FETCH_COMPETITIONS_SUCCESS: "FETCH_COMPETITIONS_SUCCESS",
  FETCH_COMPETITIONS_FAILURE: "FETCH_COMPETITIONS_FAILURE",

  FETCH_COMPETITION_DETAIL_START: "FETCH_COMPETITION_DETAIL_START",
  FETCH_COMPETITION_DETAIL_SUCCESS: "FETCH_COMPETITION_DETAIL_SUCCESS",
  FETCH_COMPETITION_DETAIL_FAILURE: "FETCH_COMPETITION_DETAIL_FAILURE",

  FETCH_MY_EVENTS_START: "FETCH_MY_EVENTS_START",
  FETCH_MY_EVENTS_SUCCESS: "FETCH_MY_EVENTS_SUCCESS",
  FETCH_MY_EVENTS_FAILURE: "FETCH_MY_EVENTS_FAILURE",

  JOIN_COMPETITION_START: "JOIN_COMPETITION_START",
  JOIN_COMPETITION_SUCCESS: "JOIN_COMPETITION_SUCCESS",
  JOIN_COMPETITION_FAILURE: "JOIN_COMPETITION_FAILURE",

  REPORT_SCORE_START: "REPORT_SCORE_START",
  REPORT_SCORE_SUCCESS: "REPORT_SCORE_SUCCESS",
  REPORT_SCORE_FAILURE: "REPORT_SCORE_FAILURE",

  SUBMIT_DISPUTE_EVIDENCE_START: "SUBMIT_DISPUTE_EVIDENCE_START",
  SUBMIT_DISPUTE_EVIDENCE_SUCCESS: "SUBMIT_DISPUTE_EVIDENCE_SUCCESS",
  SUBMIT_DISPUTE_EVIDENCE_FAILURE: "SUBMIT_DISPUTE_EVIDENCE_FAILURE",

  FETCH_PLATFORMS_START: "FETCH_PLATFORMS_START",
  FETCH_PLATFORMS_SUCCESS: "FETCH_PLATFORMS_SUCCESS",
  FETCH_PLATFORMS_FAILURE: "FETCH_PLATFORMS_FAILURE",

  FETCH_CATEGORIES_START: "FETCH_CATEGORIES_START",
  FETCH_CATEGORIES_SUCCESS: "FETCH_CATEGORIES_SUCCESS",
  FETCH_CATEGORIES_FAILURE: "FETCH_CATEGORIES_FAILURE",

  FETCH_SUPPORTED_GAMES_START: "FETCH_SUPPORTED_GAMES_START",
  FETCH_SUPPORTED_GAMES_SUCCESS: "FETCH_SUPPORTED_GAMES_SUCCESS",
  FETCH_SUPPORTED_GAMES_FAILURE: "FETCH_SUPPORTED_GAMES_FAILURE",

  DELETE_COMPETITION_START: "DELETE_COMPETITION_START",
  DELETE_COMPETITION_SUCCESS: "DELETE_COMPETITION_SUCCESS",
  DELETE_COMPETITION_FAILURE: "DELETE_COMPETITION_FAILURE",

  EDIT_COMPETITION_START: "EDIT_COMPETITION_START",
  EDIT_COMPETITION_SUCCESS: "EDIT_COMPETITION_SUCCESS",
  EDIT_COMPETITION_FAILURE: "EDIT_COMPETITION_FAILURE",

  PUBLISH_COMPETITION_START: "PUBLISH_COMPETITION_START",
  PUBLISH_COMPETITION_SUCCESS: "PUBLISH_COMPETITION_SUCCESS",
  PUBLISH_COMPETITION_FAILURE: "PUBLISH_COMPETITION_FAILURE",

  CLEAR_COMPETITION_MESSAGES: "CLEAR_COMPETITION_MESSAGES",

  UPLOAD_COMPETITION_IMAGES_START: "UPLOAD_COMPETITION_IMAGES_START",
  UPLOAD_COMPETITION_IMAGES_SUCCESS: "UPLOAD_COMPETITION_IMAGES_SUCCESS",
  UPLOAD_COMPETITION_IMAGES_FAILURE: "UPLOAD_COMPETITION_IMAGES_FAILURE",

  CLEAR_CREATED_COMPETITION: "CLEAR_CREATED_COMPETITION",

  FETCH_PUBLIC_EVENTS_START: "FETCH_PUBLIC_EVENTS_START",
  FETCH_PUBLIC_EVENTS_SUCCESS: "FETCH_PUBLIC_EVENTS_SUCCESS",
  FETCH_PUBLIC_EVENTS_FAILURE: "FETCH_PUBLIC_EVENTS_FAILURE",

  // Challenge Ladder/Pairs
  FETCH_CHALLENGE_LADDER_START: "FETCH_CHALLENGE_LADDER_START",
  FETCH_CHALLENGE_LADDER_SUCCESS: "FETCH_CHALLENGE_LADDER_SUCCESS",
  FETCH_CHALLENGE_LADDER_FAILURE: "FETCH_CHALLENGE_LADDER_FAILURE",

  // Challenge Winner Management
  SUBMIT_CHALLENGE_WINNER_START: "SUBMIT_CHALLENGE_WINNER_START",
  SUBMIT_CHALLENGE_WINNER_SUCCESS: "SUBMIT_CHALLENGE_WINNER_SUCCESS",
  SUBMIT_CHALLENGE_WINNER_FAILURE: "SUBMIT_CHALLENGE_WINNER_FAILURE",

  VERIFY_CHALLENGE_WINNER_START: "VERIFY_CHALLENGE_WINNER_START",
  VERIFY_CHALLENGE_WINNER_SUCCESS: "VERIFY_CHALLENGE_WINNER_SUCCESS",
  VERIFY_CHALLENGE_WINNER_FAILURE: "VERIFY_CHALLENGE_WINNER_FAILURE",

  ADVANCE_CHALLENGE_ROUND_START: "ADVANCE_CHALLENGE_ROUND_START",
  ADVANCE_CHALLENGE_ROUND_SUCCESS: "ADVANCE_CHALLENGE_ROUND_SUCCESS",
  ADVANCE_CHALLENGE_ROUND_FAILURE: "ADVANCE_CHALLENGE_ROUND_FAILURE",

  // Challenge Lifecycle Management
  VERIFY_CHALLENGE_START: "VERIFY_CHALLENGE_START",
  VERIFY_CHALLENGE_SUCCESS: "VERIFY_CHALLENGE_SUCCESS",
  VERIFY_CHALLENGE_FAILURE: "VERIFY_CHALLENGE_FAILURE",

  COMMENCE_CHALLENGE_START: "COMMENCE_CHALLENGE_START",
  COMMENCE_CHALLENGE_SUCCESS: "COMMENCE_CHALLENGE_SUCCESS",
  COMMENCE_CHALLENGE_FAILURE: "COMMENCE_CHALLENGE_FAILURE",

  END_CHALLENGE_START: "END_CHALLENGE_START",
  END_CHALLENGE_SUCCESS: "END_CHALLENGE_SUCCESS",
  END_CHALLENGE_FAILURE: "END_CHALLENGE_FAILURE",

  // Unsubscribe from competition
  UNSUBSCRIBE_COMPETITION_START: "UNSUBSCRIBE_COMPETITION_START",
  UNSUBSCRIBE_COMPETITION_SUCCESS: "UNSUBSCRIBE_COMPETITION_SUCCESS",
  UNSUBSCRIBE_COMPETITION_FAILURE: "UNSUBSCRIBE_COMPETITION_FAILURE",

  CLEAR_CHALLENGE_LADDER: "CLEAR_CHALLENGE_LADDER",

  // Homepage dedicated slices (separate from shared publicEvents)
  FETCH_PUBLIC_CHALLENGES_START: "FETCH_PUBLIC_CHALLENGES_START",
  FETCH_PUBLIC_CHALLENGES_SUCCESS: "FETCH_PUBLIC_CHALLENGES_SUCCESS",
  FETCH_PUBLIC_CHALLENGES_FAILURE: "FETCH_PUBLIC_CHALLENGES_FAILURE",

  FETCH_PUBLIC_ONE_V_ONES_START: "FETCH_PUBLIC_ONE_V_ONES_START",
  FETCH_PUBLIC_ONE_V_ONES_SUCCESS: "FETCH_PUBLIC_ONE_V_ONES_SUCCESS",
  FETCH_PUBLIC_ONE_V_ONES_FAILURE: "FETCH_PUBLIC_ONE_V_ONES_FAILURE",
};

export default competitionActionTypes;
